import { useState, useEffect, useRef } from 'react';
import { getFileRecords, deleteRecord } from '@/bussiness/AudioImportHandler';
import fileImportStore from '@/store/fileImport.store';
import IC_UPLOADING from '@/assets/import/ic_uploading.svg?react';
import IC_ARROW_UP from '@/assets/import/ic_arrow_up.svg?react';
import IC_ARROW_DOWN from '@/assets/import/ic_arrow_down.svg?react';
import './index.less';
import UploadStationItem from './UploadStationItem';
import Dialog from '@/component/Dialog';

export default function UploadStation() {

  const records = fileImportStore((store) => store.fileRecords);

  const [isMaximize, setIsMaximize] = useState(true);
  const [choseName, setChoseName] = useState('');
  const [choseId, setChoseId] = useState('');

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  // 使用 useRef 避免严格模式下重复调用
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      getFileRecords();
    }
  }, []);

  const handleToggleMaximize = () => {
    setIsMaximize(!isMaximize);
  };

  const handleDelete = (name: string, id: string) => {
    setChoseName(name);
    setChoseId(id);
    setShowDeleteDialog(true);
  };

  const handleDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const handleConfirmDelete = () => {
    deleteRecord(choseId);
    setShowDeleteDialog(false);
  };

  const displayName = choseName.length > 20 ? choseName.substring(0, 20) + '...' : choseName;

  if (records.length === 0) {
    return null;
  }

  return (
    <div className='absolute right-6 bottom-6 z-99 flex flex-col bg-white rd-2 shadow-[0px_2px_20px_0px_#0000001F]'>
      <Dialog
        isOpen={showDeleteDialog}
        title=''
        content={`确认要删除"${displayName}"转写任务吗？`}
        confirmText='确认'
        onCancel={handleDeleteDialog}
        onConfirm={handleConfirmDelete}
      />
      {isMaximize ? (
        <div className='flex flex-col w-112 h-80 py-3'>
          <div className='flex px-4 pb-4 border-b-#ECEEF3 border-b-1 border-b-solid'>
            <span className='text-#0D062D text-size-3.5 font-bold flex-1'>
              上传/转写中（{records.length}）
            </span>
            <IC_ARROW_DOWN
              className='w-4.5 h-4.5 cursor-pointer'
              onClick={handleToggleMaximize}
            />
          </div>
          <div className='overflow-hidden overflow-y-scroll'>
            {records.map((record) => (
              <UploadStationItem
                key={record.id}
                record={record}
                onDelete={handleDelete}
              />
            ))}
          </div>
        </div>
      ) : (
        <div
          className='flex h-12 py-3 px-4 border-1 border-solid border-#ECEEF3'
          onClick={handleToggleMaximize}
        >
          <IC_UPLOADING className='w-6 h-6' />
          <span className='text-#0D062D text-size-3.5 font-bold mx-2'>
            上传/转写中（{records.length}）
          </span>
          <IC_ARROW_UP className='w-4.5 h-4.5 cursor-pointer' />
        </div>
      )}
    </div>
  );
}
